<div class="fe-layer" id="_exchangeLayer">
    <div class="fe-layer-main layer-sm">
        <div class="fe-layer-header">
            <span class="title">积分兑换</span>
            <div class="delete-btn">
                <a href="javascript:;" title="关闭" role="button" class="iconfont close-layer-btn icon-guanbi3 _closeCurrLayerBtn"></a>
            </div>
        </div>
        <div class="fe-layer-content">
            <div class="tips-content">
                {{if $data.allScore >= $data.needScore}}
                <p>您当前共有积分{{$data.allScore}}分，本次兑换需要消耗{{$data.needScore}}分，是否进行兑换？</p>
                {{else}}
                <p>您当前共有积分{{$data.allScore}}分，本次兑换需要消耗{{$data.needScore}}分，积分不足，快去科技工作者之家APP做任务、赚积分吧~</p>
                {{/if}}
            </div>
            <div class="button-list {{if $data.allScore >= $data.needScore}} two-btn{{else}}{{/if}}">
                {{if $data.allScore >= $data.needScore}}
                    <a href="javascript:;" role="button" class="fe-btn btn-radius btn-active layer-btn transition-btn _sureExchangeBtn">确定</a>
                    <a href="javascript:;" role="button" class="fe-btn btn-radius _closeCurrLayerBtn layer-btn">取消</a>
                {{else}}
                    <a href="javascript:;" role="button" class="fe-btn btn-radius btn-active layer-btn _closeCurrLayerBtn transition-btn">知道了</a>
                {{/if}}
            </div>
        </div>
    </div>
</div>